import { useCallback } from "react";

import { prop, define } from "@/components/builder/utils";
import RootBackground from "@/components/builder/utils/RootBackground";
import { useStoreLayouts } from '@/modules/cms/views/post/components/builder/context'

function TemplateRootPreview({ children }) {
  return <RootBackground>
    {children}
  </RootBackground>
}

function TemplateRootHTML({ children }) {
  return <>
    {`{{!< ../../src/builder/layouts/builder-default}}`}
    {children}
  </>
}

function useLayoutOptions() {
  const { items } = useStoreLayouts()

  return useCallback(async () => ({
    options: items.map(({ name }) => ({
      value: name,
      label: name,
    })),
  }), [items])
}

export default define('template_root', TemplateRootPreview, TemplateRootHTML)
  .property(prop.select.async('Layout', 'layout')
    .category('default')
    .props({
      useOptions: useLayoutOptions,
    }))
  .build()
